import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const getAnonymousWishlistProps = z
  .object({
    wishlistToken: z.string(),
    wishlistId: z.string(),
    items: z.number().optional(),
    page: z.number().optional(),
  })
  .extend(requestConfig.shape);

export type GetAnonymousWishlistProps = z.infer<
  typeof getAnonymousWishlistProps
>;

export const getAnonymousWishlist = async (
  args: GetAnonymousWishlistProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    wishlistToken,
    wishlistId,
    page,
    items,
  } = parseServiceInput(getAnonymousWishlistProps, args);

  const params = new URLSearchParams();
  if (page) params.set("page", page.toString());
  if (items) params.set("pageSize", items.toString());

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
  });
  if (wishlistToken) {
    headers.append("x-api-token", `Bearer ${wishlistToken}`);
  }

  const response = await fetch(
    `${endpoint}/v1/wishlist/anonymous/${wishlistId}?${params.toString()}`,
    {
      method: "GET",
      headers,
    },
  );

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
